// extracted by mini-css-extract-plugin
export default {"fluid":"fluid-Wq7Ug","container":"container-h9I75"};